(function () {
    'use strict';

    angular
        .module('app.accountDetails')
        .factory('accountDetailsService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAccountDetails(account_id, loader) {
                    var url_getAccountDetails = $rootScope.apiUrl + 'account/getCompanyById/' + account_id;
                    return handleRequest(url_getAccountDetails, 'GET', null, loader);
                }

                function getUserById(user_id, loader) {
                    var url_getUserById = $rootScope.apiUrl + 'admin/getUserById/' + user_id;
                    return handleRequest(url_getUserById, 'GET', null, loader);
                }

                function getGoverningAgencyByCompany(params, loader) {
                    var url_getGoverningAgencyByCompany = $rootScope.apiUrl + 'admin/getGoverningAgencyByCompany/' + params;
                    return handleRequest(url_getGoverningAgencyByCompany, 'GET', null, loader);
                }

                function getAllGoverningAgency(loader) {
                    var url_getAllGoverningAgency = $rootScope.apiUrl + 'admin/getAllGoverningAgency';
                    return handleRequest(url_getAllGoverningAgency, 'GET', null, loader);
                }

                function updateAccount(params, loader) {
                    var url_updateAccount = $rootScope.apiUrl + 'account/updateAccount';
                    return handleRequest(url_updateAccount, 'POST', params, loader);
                }

                function getAccountAddresses(account_id, loader) {
                    var url_getAccountAddresses = $rootScope.apiUrl + 'account/getAccountAddresses/' + account_id; 
                    return handleRequest(url_getAccountAddresses, 'GET', null, loader);
                }

                service.getAccountDetails = getAccountDetails;
                service.getUserById = getUserById;
                service.getGoverningAgencyByCompany = getGoverningAgencyByCompany;
                service.getAllGoverningAgency = getAllGoverningAgency;
                service.updateAccount = updateAccount;
                service.getAccountAddresses = getAccountAddresses;

                return service;
            }
        ]);
})();
